<template>
  <el-dialog
    title="订单审核"
    :visible.sync="dialogVisible"
    width="650px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="confirmtips">
      <i class="el-icon-warning"></i>
      <div style="margin-left: 10px">
      <span style="font-size: 16px">该笔订单实付款¥{{form.totalCost || 0}}元，确认{{info.typeValue}}吗?</span>
      <div class="tipsColor" v-if="info.type == 2"> {{info.tips}}</div>
      </div>
    </div>
    <div class="checkRemark">
    <el-input  type="textarea" v-model="checkRemark" placeholder="请填写审核备注" maxlength="50" show-word-limit></el-input>
    </div>
    <div style="text-align: center;margin-top: 40px">
      <el-button @click="close()" size="small">取消</el-button>
      <el-button @click="handleSubmit()" type="primary" size="small" v-preventClick>{{info.typeValue}}</el-button>
    </div>
    <tipsDialog ref="tipsDialog" v-if="tipsDialogVisible"></tipsDialog>
  </el-dialog>
</template>
<script>
import { orderCheck } from "@/api/request";
import tipsDialog from "./tipsDialog"
export default {
  components: {
      tipsDialog
  },  
  data() {
    return {
      dialogVisible: false,
      tipsDialogVisible: false,
      checkRemark: "",
      form: {},
      info: {}
    };
  },
  methods: {
    init(row,info) {
      this.dialogVisible = true;
      this.form = row;
      this.checkRemark = ''
      this.$nextTick(() => {
        this.info = info;
      });
    },
    handleSubmit () {
        orderCheck({
            orderId: this.form.orderId,
            checkStatus: this.info.type,//type从前面传过来，2审核通过，3审核拒绝
            checkRemark: this.checkRemark
        }).then(res=> {
            this.dialogVisible = false
            this.$emit('back')
            this.$message.success("操作成功");
        },error => {
            this.tipsDialogVisible = true;
            this.dialogVisible = false
            this.$nextTick(()=> {
                let obj = {
                title: '操作失败',
                tips: error,
                width: '500px',
                icon: 'el-icon-warning'
                }
                this.$refs.tipsDialog.init({},obj)
            })
        })
    },
    close() {
      this.dialogVisible = false;
    }
  }
};
</script>
<style scoped>
.el-icon-warning {
    font-size: 30px;
    color: #E6A23C;
}
.tipsColor {
    margin: 5px 0;
    width: 100%;
    text-align: center;
    color: #E6A23C;
}
.confirmtips {
    width: 100%;
    display: flex;
    flex-flow: row;
    justify-content: center;
    align-items: center;
    font-size: 15px;
}
.checkRemark {
    width: 75%;
    margin: 10px auto;
}
</style>